import Loan from './data/loan.json';
import LoginCode from './data/login-code.json';
import StepOne from './data/onboarding-step-one.json';
import StepTwoMock from './data/onboarding-step-two-mock.json';
import StepTwo from './data/onboarding-step-two.json';
import PreLoan from './data/preloan.json';

import { URLS, URLS_MOCK as MOCK } from '../mo-api/url.constants';
import { CUSTOMER_MOCK as CUSTOMER } from './data/customer';
import { TRANSACTIONS_MOCK as TRANSACTIONS } from './data/transactions';
import { LOGIN } from './data/login';

import { CARD_MOCK } from './data/card-info';
import OffersByMerchant from './data/offers-by-merchant.json';
import { OFFER_PREVIEW } from './data/offers-preview';
import { MOCK_CHECK_PENDING_PAYMENTS_EMPTY, MOCK_PAYMENTS_SUCCESS } from './data/payments.mock';
import { PRE_CUSTOMER } from './data/pre-customer';
import { ORDER_MOCKS as ORDER } from './data/order.mocks';
import { AVAILABLE_OFFERS } from './data/available-offers.mock';
import { BIOMETRICS_MOCK } from './data/biometrics.mock';
import { CUSTOMER_SCORE_MOCK } from './data/customer-score.mock';

export const ROUTES_MOCK = [
  { url: `^${URLS.PUT_RECORD}$`, data: {}, method: 'POST' },
  { url: `^${URLS.TRANSACTIONS}$`, data: TRANSACTIONS.PENDING, method: 'GET' },
  { url: `^${URLS.TRANSACTIONS}$`, data: TRANSACTIONS.PENDING, method: 'PATCH' },
  { url: `^${URLS.TRANSACTIONS}$`, data: TRANSACTIONS.PENDING, method: 'DELETE' },
  { url: `^${MOCK.OFFERS_BY_MERCHANT}$`, data: OffersByMerchant, method: 'GET' },
  { url: `^${MOCK.OFFERS_BY_MERCHANT_AMOUNT}$`, data: OffersByMerchant, method: 'GET' },
  {
    url: `^${MOCK.OFFER_PREVIEW}$`,
    data: OFFER_PREVIEW.OFFER_6,
    method: 'GET',
  },
  { url: `^${URLS.LOGIN_CODE}$`, data: LoginCode, method: 'POST' },
  { url: `^${URLS.LOGIN}$`, data: LOGIN.NOT_CUSTOMER, method: 'POST' },
  { url: '^/onboarding/step/1/$', data: StepOne, method: 'GET' },
  { url: '^/onboarding/step/2/$', data: StepTwo, method: 'GET' },
  { url: '^/onboarding/step/1/$', data: StepTwo, method: 'POST' },
  { url: '^/onboarding/step/2/$', data: {}, method: 'POST' },
  { url: '^/onboarding-mock/step/2/$', data: StepTwoMock, method: 'POST' },
  // PRIMER VALIDATION DESPUÉS DEL LOGIN
  {
    url: `^${MOCK.VALIDATION_CUSTOMER}$`,
    data: CUSTOMER.VALIDATION_APPROVED_WITH_CAN_REQUEST_VALIDATOR,
    method: 'GET',
  },
  // LISTEN CUSTOMER VALIDATION - CUSTOMER EFFECTS
  {
    url: `^${URLS.VALIDATE_CUSTOMER}$`,
    data: CUSTOMER.VALIDATE_PENDING,
    method: 'POST',
  },
  {
    url: `^${MOCK.VALIDATION_CUSTOMER}$`,
    data: CUSTOMER.VALIDATION_APPROVED_DEFAULT,
    method: 'GET',
  },
  {
    url: `^${URLS.PRE_CUSTOMER}$`,
    data: PRE_CUSTOMER.FAST_ONBOARDING_DISABLED_WITHOUT_DATA,
    method: 'GET',
  },
  { url: `^${URLS.CUSTOMER}$`, data: CUSTOMER.VALIDATE_PENDING, method: 'GET' },
  { url: `^${URLS.PRE_CUSTOMER}$`, data: {}, method: 'PATCH' },
  { url: `^${MOCK.PRE_CUSTOMERS_STEP_1}$`, data: {}, method: 'PATCH' },
  { url: `^${MOCK.PRE_CUSTOMERS_STEP_2}$`, data: {}, method: 'PATCH' },
  {
    url: `^${URLS.PRE_CUSTOMER}$`,
    data: PRE_CUSTOMER.FAST_ONBOARDING_DISABLED_WITH_DATA,
    method: 'GET',
  },
  { url: `^${URLS.UPGRADE_CUSTOMER}$`, data: {}, method: 'POST' },
  {
    url: `^${URLS.VALIDATE_CUSTOMER}$`,
    data: CUSTOMER.VALIDATE_PENDING,
    method: 'GET',
  },
  {
    url: `^${URLS.VALIDATE_CUSTOMER}$`,
    data: CUSTOMER.VALIDATE_PENDING,
    method: 'GET',
  },
  {
    url: `^${MOCK.VALIDATION_CUSTOMER}$`,
    data: CUSTOMER.VALIDATE_PENDING,
    method: 'GET',
  },

  {
    url: `^${URLS.VALIDATION_AGGREGATOR}$`,
    data: CUSTOMER.VALIDATION_AGGREGATOR_APPROVED,
    method: 'GET',
  },

  {
    url: `^${URLS.VALIDATION_MAX_INSTALLMENT}$`,
    data: CUSTOMER.VALIDATION_MAX_INSTALLMENT_APPROVED_CASE_1,
    method: 'GET',
  },

  {
    url: `^${URLS.VALIDATION_DEBIT}$`,
    data: {},
    method: 'GET',
  },

  {
    url: `^${MOCK.CHECK_PENDING_PAYMENTS}$`,
    data: MOCK_CHECK_PENDING_PAYMENTS_EMPTY,
    method: 'GET',
  },

  {
    url: `^${URLS.PRE_CUSTOMER}$`,
    data: PRE_CUSTOMER.FAST_ONBOARDING_ENABLED_WITH_DATA,
    method: 'GET',
  },

  {
    url: `^${MOCK.AVAILABLE_OFFERS}$`,
    data: AVAILABLE_OFFERS,
    method: 'GET',
  },

  {
    url: `^${MOCK.AVAILABLE_SCORE}$`,
    data: AVAILABLE_OFFERS,
    method: 'GET',
  },

  { url: `^${URLS.GET_CARD}$`, data: {}, method: 'GET' },

  { url: '^/kyc/application/$', data: {}, method: 'POST' },
  { url: '^/loans/$', data: Loan, method: 'POST' },
  { url: '^/loans/preview/$', data: PreLoan, method: 'GET' },
  { url: `^${URLS.PRE_LOANS}$`, data: { id: '123123' }, method: 'POST' },
  { url: `^${URLS.CREATE_CREDIT_CARD}$`, data: {}, method: 'POST' },
  { url: `^${MOCK.CREATE_PAYMENTS}$`, data: MOCK_PAYMENTS_SUCCESS, method: 'POST' },
  // { url: `^${URLS.PAYMENTS}$`, data: MOCK_PAYMENTS_SUCCESS, method: 'POST' },
  { url: `^${URLS.MERCHANT_TRANSACTIONS}$`, data: {}, method: 'PATCH' },
  { url: `^${URLS.GET_ORDER}$`, data: ORDER.PROCESSED, method: 'GET' },
  {
    url: `^${URLS.GET_KEYNUA_WIDGET_TOKEN}$`,
    data: BIOMETRICS_MOCK.NEW,
    method: 'GET',
  },
  {
    url: `^${URLS.GET_KEYNUA_WIDGET_STATUS}$`,
    data: BIOMETRICS_MOCK.ERROR,
    method: 'GET',
  },
  { url: `^${URLS.CUSTOMER_SCORE}$`, data: CUSTOMER_SCORE_MOCK.SCORE_APPROVED, methos: 'GET' },
];

export const REQUEST_MOCK_TRANSACTION = {
  url: `${URLS.TRANSACTIONS}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
  urlWithParams: '/login/',
};

export const OFFER_MOCK_PREVIEW = {
  url: `${MOCK.OFFER_PREVIEW}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
};

export const REQUEST_MOCK_KYC = {
  url: '/onboarding-mock/step/2/',
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'POST',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
  urlWithParams: '/login/',
};

export const REQUEST_MOCK_SCORE = {
  url: `${URLS.VALIDATE_CUSTOMER}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
  urlWithParams: '/login/',
};

export const REQUEST_MOCK_VALIDATE = {
  url: `${URLS.VALIDATE_CUSTOMER}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'POST',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
  urlWithParams: '/login/',
};

export const REQUEST_MOCK_VALIDATION = {
  url: `${URLS.VALIDATION_CUSTOMER}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: {
      transaction_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
      session_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
    },
  },
  urlWithParams: `${URLS.VALIDATION_CUSTOMER}?transaction_id=28mockbf-377c-43b1-ba61-5ecc1mock357&session_id=28mockbf-377c-43b1-ba61-5ecc1mock357`,
};

export const REQUEST_MOCK_KILL_PURCHASE = {
  url: `${URLS.TRANSACTIONS}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'DELETE',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
  urlWithParams: '/login/',
};

export const REQUEST_PATCH_TRANSACTION = {
  url: `${URLS.TRANSACTIONS}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'PATCH',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
  urlWithParams: '/login/',
};

export const REQUEST_GET_ORDER = {
  url: `${URLS.GET_ORDER}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
  urlWithParams: '/login/',
};

export const GET_KEYNUA_WIDGET_TOKEN = {
  url: `${MOCK.KEYNUA_WIDGET_TOKEN}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
  urlWithParams: '/login/',
};

export const GET_KEYNUA_WIDGET_STATUS = {
  url: `${MOCK.KEYNUA_WIDGET_STATUS}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: null,
  },
  urlWithParams: '/login/',
};

export const REQUEST_MOCK_AVAILABLE_SCORE = {
  url: `${URLS.GET_AVAILABLE_SCORE}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: {
      transaction_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
    },
  },
  urlWithParams: `${URLS.GET_AVAILABLE_SCORE}?transaction_id=28mockbf-377c-43b1-ba61-5ecc1mock357&session_id=28mockbf-377c-43b1-ba61-5ecc1mock357`,
};

export const REQUEST_MOCK_VALIDATION_AGGREGATOR = {
  url: `${URLS.VALIDATION_AGGREGATOR}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: {
      transaction_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
      session_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
    },
  },
  urlWithParams: `${URLS.VALIDATION_AGGREGATOR}?transaction_id=28mockbf-377c-43b1-ba61-5ecc1mock357&session_id=28mockbf-377c-43b1-ba61-5ecc1mock357`,
};

export const REQUEST_MOCK_VALIDATION_MAX_INSTALLMENT = {
  url: `${URLS.VALIDATION_MAX_INSTALLMENT}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: {
      transaction_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
      session_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
    },
  },
  urlWithParams: `${URLS.VALIDATION_MAX_INSTALLMENT}?transaction_id=28mockbf-377c-43b1-ba61-5ecc1mock357&session_id=28mockbf-377c-43b1-ba61-5ecc1mock357`,
};

export const REQUEST_MOCK_VALIDATION_DEBIT = {
  url: `${URLS.VALIDATION_DEBIT}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: {
      transaction_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
      session_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
    },
  },
  urlWithParams: `${URLS.VALIDATION_DEBIT}?transaction_id=28mockbf-377c-43b1-ba61-5ecc1mock357&session_id=28mockbf-377c-43b1-ba61-5ecc1mock357`,
};

export const REQUEST_MOCK_AVAILABLE_OFFERS = {
  url: `${URLS.GET_AVAILABLE_OFFERS}`,
  body: null,
  reportProgress: false,
  withCredentials: false,
  responseType: 'json',
  method: 'GET',
  headers: {
    normalizedNames: {},
    lazyUpdate: null,
    headers: {},
  },
  context: {
    map: {},
  },
  params: {
    updates: null,
    cloneFrom: null,
    encoder: {},
    map: {
      transaction_id: '28mockbf-377c-43b1-ba61-5ecc1mock357',
    },
  },
  urlWithParams: `${URLS.GET_AVAILABLE_OFFERS}?transaction_id=28mockbf-377c-43b1-ba61-5ecc1mock357`,
};
